import React from 'react';
import { StatusTypes } from 'models/Task';
import { Col, Row, Badge } from 'components';
import { useTaskStatusAnalyticsQuery } from 'api';
import { AnalyticsCard } from 'components/common/analyticsCard';
import { STATUS_MAPPING, StatusType } from 'components/common/StatusBadge';
import './styles.scss';

export const StatusAnalytics = React.memo(() => {
  const { data: statusAnalytics = {} } = useTaskStatusAnalyticsQuery();
  return (
    <Row className={'task-status-analytics'} gutter={[16, 16]}>
      {Object.values(StatusTypes).map((status) => (
        <Col key={status.value}>
          <AnalyticsCard
            icon={
              <Badge style={{ width: 10, height: 10 }} color={STATUS_MAPPING[status.value as StatusType].dotColor} />
            }
            width={'250px'}
            title={status.label}
            analyticData={statusAnalytics[status.value] || 0}
            analyticText={'Current Month'}
          />
        </Col>
      ))}
    </Row>
  );
});
